import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import HistoryComponent from '../views/HistoryComponent.vue'
import qualificationsHonors from  '@/views/qualificationsHonors.vue'
import promotionalVideo from  '@/views/promotionalVideo.vue'
import videoDetails from  '@/views/videoDetails.vue'
import newsConsultation from '@/views/newsConsultation.vue'
import newsDetails from '@/views/newsDetails.vue'
import productDisplay from '@/views/productDisplay.vue'
import productDetails from '@/views/productDetails.vue'
import DownloadMessage from '@/views/downloadMessage.vue'
import customerCase from '@/views/customerCase.vue'
import caseDetails from '@/views/caseDetails.vue'
import contactUs from '@/views/contactUs.vue'
import OnlineCenter  from '@/views/onlineCenter.vue'
import ApiDemo from '@/views/ApiDemo.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/HistoryComponent',
    name: 'history',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: HistoryComponent
  },
  {
    path: '/qualificationsHonors',
    name: 'qualificationsHonors',
    component: qualificationsHonors
  },
  {
    path: '/promotionalVideo',
    name: 'promotionalVideo',
    component: promotionalVideo
  },
  {
    path: '/videoDetails',
    name: 'videoDetails',
    component: videoDetails
  },
  {
    path: '/newsConsultation',
    name: 'newsConsultation',
    component: newsConsultation
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: newsDetails
  },
  {
    path: '/productDisplay',
    name: 'productDisplay',
    component: productDisplay
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    component: productDetails
  },
  {
    path: '/customerCase',
    name: 'customerCase',
    component: customerCase
  },
  {
    path: '/caseDetails',
    name: 'caseDetails',
    component: caseDetails
  },
  {
    path: '/DownloadMessage',
    name: 'download',
    component: DownloadMessage
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: contactUs
  },
  {
    path: '/OnlineCenter',
    name: 'online',
    component: OnlineCenter
  },
  {
    path: '/api-demo',
    name: 'apiDemo',
    component: ApiDemo
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
